import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth23: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.6,51.2l13.8-15.3L68.8.8l37.9,12.3,18.1,17.8,3.5,14.3.8,5,1,11-.5,19.8-1,10.8-1,15.5-1.5,6.8-1.5,7.3-2,8.5-1.3,6.5-1.8,6.3-1.5,7.3-2,7.3-5.3,16-4.5,11-3.3,5.8-3.8,4-6.3,2.5-5.5.3-8.8-2.3-4.8-.8-6,.3-4-.8-6.5-2.5-6.3-2-6.8-2.3-4.5-2.5-4.5-2.8-5.8-4.3-1.3-2.5-2-10.8-1.5-9.5-2-8.8-4.3-10.3-4.5-9.5-4-15.8s-2.8-13.5-2.8-14.3-.3-21.8-.3-21.8l7.8-22.6Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M14.6,51.2l13.8-15.3L68.8.8l37.9,12.3,18.1,17.8,3.5,14.3.8,5,1,11-.5,19.8-1,10.8-1,15.5-1.5,6.8-1.5,7.3-2,8.5-1.3,6.5-1.8,6.3-1.5,7.3-2,7.3-5.3,16-4.5,11-3.3,5.8-3.8,4-6.3,2.5-5.5.3-8.8-2.3-4.8-.8-6,.3-4-.8-6.5-2.5-6.3-2-6.8-2.3-4.5-2.5-4.5-2.8-5.8-4.3-1.3-2.5-2-10.8-1.5-9.5-2-8.8-4.3-10.3-4.5-9.5-4-15.8s-2.8-13.5-2.8-14.3-.3-21.8-.3-21.8l7.8-22.6Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M86.6,92.5c0,9.44-7.43,17.1-16.6,17.1s-16.6-7.66-16.6-17.1 7.43-17.1 16.6-17.1 16.6,7.66 16.6,17.1z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M7.5,83.7l-.2,10.4,1.9,13.4,6.6,21.9s64.3-43.1-8.2-45.7Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M128.8,84.9l-.2,12.2-1.6,12.2-1.9,11.1-2.4,9s-76.5-35.3,6.1-44.5Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M27.3,170.1l-1.9-12.5-3.3-10.8-4.9-14.1-4.7-15.1-3.1-13-1.9-10.4-.2-21.4,7.1-19.5,14.1-16.5,14.1-15.3,16.3-12.2s0,79.8-31.6,160.9Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M89.2,7.4l18.6,7.5,16.5,17,3.8,13.9,1.2,12.7.2,21.2-1.4,17.9-.9,12-3.8,17.2-3.5,13.2-2.4,14.6-2.6,9.4-1.9,3.3S67.1,81.8,89.2,7.4Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M115.2,185.7l2.8-35.7-2,7.3-5.3,16-4.5,11-3.3,5.8-3.8,4-6.3,2.5-5.5.3-8.8-2.3-4.8-.8-6,.3-4-.8-6.5-2.5-6.3-2-6.8-2.3-4.5-2.5-4.5-2.8-5.8-4.3-1.3-2.5,1.4,14.6s54.2,47.1,85.7-3.3Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '22.4 43.2 33.4 30 68.8 1 107.1 14 124.8 31.2 127.9 44.3 20.9 44.3 22.4 43.2',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'7.4 89.6 20.1 108.8 26.4 81.9 34.9 114.7 45.9 81 56.1 114.7 67.5 81.4 77.9 114.7 89.3 79.2 98.5 112.9 110.9 79.2 114.6 107.5 128.2 87.3',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'68.5 194.8 56.9 202.8 70.1 212.5 58.2 220.9 70.6 229.7 59.3 237.5 70.4 245.5 59.3 253.1 72.1 262.2 61.4 269.6 71.6 276.8 60.9 284.2 73.3 288.1 61.9 297.3 77.1 303 64.1 310.3 79.7 312.7 66.9 321.2 81.3 329.9 68.8 337.2 83.2 347.2 69 356.6 83.9 365.1 69.7 372.9 85.1 381.2 71.1 389.9 86.3 397.7 73.6 405.8 84.2 418.4',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'37.7 283.5 41.7 296.9 46.4 282.8 51.5 295.6 57.4 283.9 64.5 297.7 71 281.1 78.8 296.9 86.4 281.1 92.9 295.6 99.4 281.5',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '8 88.7 13.4 73.6 18.5 64.3 28.8 54.6 47.2 47.2 67.9 47.5 77.7 49.8 92 57.4 110.2 72.5 123 85.1 125.8 91.2 127.6 98.1 128.4 105.1 127.1 109.2 126.6 113 122.2 121.4 118.9 124.8 106.1 136.3 98.9 143.7 95.6 149.6 93.3 152.4 84.6 158.3 78.4 161.1 74.1 163.2 62.8 163.4 54.4 160.6 49.5 158.1 41.1 152.2 38 148.8 33.1 145 29.8 141.9 26.5 137.8 19.8 129.9 16.5 127.3 12.1 119.1 8.5 111.5 6.7 101.2 8 88.7',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M36.8,74.4h48.6s-33.7-31.9-48.6,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '12.5 120 8.1 108.2 8.1 89.2 11.2 80.3 117.9 79.9 123.4 86.2 127.5 96.6 127.5 107.7 126.4 113.4 124.3 118.2 123.5 120 12.5 120',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.2,80.3l-3,9v18.9l4.3,11.9s65.4-21-1.3-39.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.9,79.9l5.4,6.3,4.2,10.4v11.1l-1.1,5.8-2.9,6.6s-77.4-19.7-5.6-40.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M8.6,105.9l-.2-16.2,2.7-11.1,5.9-11.5,4.2-6.1,8.2-6.4,13.8-6.3,7.9-1.1,16.8-.2,11.2,3.2,9.3,4.8,9.9,7.5,9.3,7.2,15.4,15.4,4.5,9.8.5,11.9s-59.1-19.1-119.4-1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.5,115l-4.3,7.5-4,4.2-9.9,8.8-10.9,11.2-3,5-6.4,5.6-6.1,3.7-6.7,1.6-3.2.8h-7.4l-6.4-1.6-9.8-5.1-10.7-9.5-7.1-6.1-7.2-7.1-7.1-8.8-4.3-8-1.8-6.6-.5-4.8s50.2-18.6,119.4,1l-2.6,8.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'9.4 99.4 24.3 113.6 27.9 90.4 39.4 118.2 48.3 90.4 59.1 119.5 69.2 92.1 79.9 119.5 89.8 91.7 100.1 119.5 108.2 92.4 114.2 114.6 126.3 98.7',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.9,330.8l17.5-13.1,9.1-5.3,6.3-2.7,4.4-1.9,3.2-.4,6.5,2.5,7.4,2.3s8.4,3,9.1,3.4,7.2,5.5,7.2,5.5l2.7,1.5h4.4l2.7,1.7,5.3,4.4,3.4,4.9,2.7,3.2,2.7,3.8,1.3,1.9,1.1,11.4,2.1,14.1,2.5,19.2,1.9,14.4.6,37.1-.8,15-1.3,9.5-6.1,15.8-16.5,16-35.9,13.1-5.9-2.7-11.8-7.6-13.1-10.1-15.8-17.1-11.4-12.9-7.2-16.7-1.1-24.3,3.6-20.3,3.8-12.2,6.3-15.4,4-12.9,1.9-10.3,3-14.8Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M29.9,330.8l17.5-13.1,9.1-5.3,6.3-2.7,4.4-1.9,3.2-.4,6.5,2.5,7.4,2.3s8.4,3,9.1,3.4,7.2,5.5,7.2,5.5l2.7,1.5h4.4l2.7,1.7,5.3,4.4,3.4,4.9,2.7,3.2,2.7,3.8,1.3,1.9,1.1,11.4,2.1,14.1,2.5,19.2,1.9,14.4.6,37.1-.8,15-1.3,9.5-6.1,15.8-16.5,16-35.9,13.1-5.9-2.7-11.8-7.6-13.1-10.1-15.8-17.1-11.4-12.9-7.2-16.7-1.1-24.3,3.6-20.3,3.8-12.2,6.3-15.4,4-12.9,1.9-10.3,3-14.8Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M48.2,369.4l52.6.2s-28.2-107.5-52.6-.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M8.3,421.6s76-14,9.1-42.6l-4.7,13.5-2.4,13.5-1.3,10.4',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M130.2,379.6l2.2,12.7,1.1,14,.4,13.5v4.7s-76.2-16.9-3.8-44.9Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '72.2 507.7 54.2 496 40.5 484.4 33.8 477.3 126 477.3 123.3 481.8 117.5 486.4 108.9 495.1 88 503.8 72.2 507.7',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M28,338.3l-3.8,17.5-5.6,19.3-5.8,16.7-3.3,16.9-1.3,7.6.2,19.5,7.8,22.9,11.5,13.1,15.3,15.3,13.3,10.9s.9-141.3-28.4-159.7Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M125.3,342.5l6,44.6,2.2,16.7.9,8.2-.2,27.5-.9,15.1-1.1,8.7-6.7,15.8-7.3,6.9-7.8,8.2-15.5,6.2s-8.4-141,30.4-157.9Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M30.7,317l-.8,13.8,17.5-13.1,19.8-9.9,3.2-.4,6.5,2.5,7.4,2.3,9.1,3.4,9.9,7h4.4l8,6.1,3.4,4.9,5.4,7,1.3,1.9-1.6-18.4s-49.5-48.2-93.5-7.1Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'133.7 415.5 121 396.2 114.8 423.2 106.3 390.3 95.3 424.1 85.1 390.3 73.7 423.7 63.3 390.3 51.9 425.9 42.6 392.1 30.3 425.9 26.6 397.5 11.1 414.9',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'72.7 310.3 84.3 302.3 71 292.6 83 284.2 70.6 275.3 81.9 267.6 70.8 259.5 81.9 252 69 242.9 79.8 235.4 69.6 228.3 80.3 220.8 69.3 212.8 80.5 205 70 197.4 81.4 189.7 71.7 182.7 82.8 174.9 71 166.4 84 157.4 72.5 149.2 85.3 140.3 73.7 131.9 86.2 123.2 72.7 113.5 84.3 105.4 74.3 93.8 86 84.7 75.1 62',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'108.2 219.4 103.4 203.5 97.9 220.1 91.9 205 84.8 218.9 76.5 202.5 68.8 222.1 59.5 203.5 50.4 222.1 42.7 205 35 221.7',
			],
		},
	},
};
